import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../common/Button"
import { filesActions } from "../../../../store/files"
import { visibleCaseDocuments } from "../../../../lib/docs"
import { documentsTypes, practicesOptions } from "../../../../lib/systemData"
import InputBox from "../../../common/interactive/InputBox"
import CustomSelect from "../../../common/interactive/CustomSelect"

import classes from './../Shared/Filters.module.css'

const DocumentsFilters = () => {
    const dispatch = useDispatch()

    const [usersOptions, setUsersOptions] = useState(null)
    // const [selectedUser, setSelectedUser] = useState(null)
    const [selectedUseriD, setSelectedUserId] = useState(null)
    const [selectedDocumentTypeId, setSelectedDocumentTypeId] = useState(null)
    const [selectedpracticesId, setSelectedpracticesId] = useState(null)
    const [keyword, setKeyword] = useState(null)

    const activeCase = useSelector(state => state.case.activeCase)
    useEffect(() => {
        if (!activeCase || !Array.isArray(activeCase.documents)) {
            return
        }

        let arr = visibleCaseDocuments(activeCase.documents)

        if (arr) {
            let users = []
            arr.forEach(item => {
                if (users.length > 0) {
                    const index = users.findIndex(object => {
                        return object.value == item?.user?.id
                    })

                    if (index < 0) {
                        if (item?.user?.id) {
                            users.push({
                                label: item?.user?.name,
                                value: item?.user?.id
                            })
                        }
                        
                    }
                } else {
                    if (item?.user?.id) {
                        users.push({
                            label: item?.user?.name,
                            value: item?.user?.id
                        })
                    }
                    
                }
                
            })
            setUsersOptions(users)            
        }

    }, [activeCase])


    const filterDocumentUser = (value) => {
        setSelectedUserId(value.data.value)
        // if (usersOptions) {
        //     setSelectedUser(usersOptions.find(item => item.value == value.data.value))
        // }
        let arr = visibleCaseDocuments(activeCase.documents).sort(function(x, y) {
            return new Date(y.created_at) - new Date(x.created_at)
        });

        if (arr) {
            let results = arr
            if (value.data.value) {
                results = arr.filter(item => item.user_id == value.data.value)
            }

            if (selectedDocumentTypeId !== null) { //document type
                results = results.filter(item => item.document_type_id == selectedDocumentTypeId)
            }
            if (selectedpracticesId !== null) { //practices
                results = results.filter(item => {
                    return item.practices.find(elem => elem.id == selectedpracticesId)
                })
            }
            if (keyword) { //keyword search
                results = results.filter(item => item.notes?.toLowerCase().includes(keyword) || item.file_name?.toLowerCase().includes(keyword))
            } 

            dispatch(filesActions.setFilterResult(results))
        }
        
    }

    const filterDocumentType = (value) => {
        setSelectedDocumentTypeId(value.data.value)
        let arr = visibleCaseDocuments(activeCase.documents).sort(function(x, y) {
            return new Date(y.created_at) - new Date(x.created_at)
        });

        if (arr) {
            let results = arr
            if (value.data.value) {
                results = arr.filter(item => item.document_type_id == value.data.value)
            }
     
            if (selectedUseriD !== null) { //user
                results = results.filter(item => item.user_id == selectedUseriD)
            }
            if (selectedpracticesId !== null) {
                results = results.filter(item => { //practices
                    return item.practices.find(elem => elem.id == selectedpracticesId)
                })
            }
            if (keyword) { //keyword search
                results = results.filter(item => item.notes?.toLowerCase().includes(keyword) || item.file_name?.toLowerCase().includes(keyword))
            } 

            dispatch(filesActions.setFilterResult(results))
        }
        
    }

    const filterPracticesHandler = (value) => {
        setSelectedpracticesId(value.data.value)
        let arr = visibleCaseDocuments(activeCase.documents).sort(function(x, y) {
            return new Date(y.created_at) - new Date(x.created_at)
        });

        if (arr) {
            let results = arr
            if (value.data.value) {
                results = arr.filter(item => {
                return item.practices.find(elem => elem.id == value.data.value)
            })
            }      
            if (selectedUseriD !== null) { //user
                results = results.filter(item => item.user_id == selectedUseriD)
            }
            if (selectedDocumentTypeId !== null) { //document type
                results = results.filter(item => item.document_type_id == selectedDocumentTypeId)
            }
            if (keyword) { //keyword search
                results = results.filter(item => item.notes?.toLowerCase().includes(keyword) || item.file_name?.toLowerCase().includes(keyword))
            } 

            dispatch(filesActions.setFilterResult(results))
        }
    }

    const searchKeywordHandler = (value) => {
        
        setKeyword(value.data.value)
        let arr = visibleCaseDocuments(activeCase.documents).sort(function(x, y) {
            return new Date(y.created_at) - new Date(x.created_at)
        });


        if (arr) {
            let results = arr
            if (value.data.value) {
                results = arr.filter(item => item.notes?.toLowerCase().includes(value.data.value.toLowerCase()) || item.file_name?.toLowerCase().includes(value.data.value.toLowerCase()))
            }   
            if (selectedUseriD !== null) { //user
                results = results.filter(item => item.user_id == selectedUseriD)
            }
            if (selectedDocumentTypeId !== null) { //document type
                results = results.filter(item => item.document_type_id == selectedDocumentTypeId)
            }
            if (selectedpracticesId !== null) {
                results = results.filter(item => { //practices
                    return item.practices.find(elem => elem.id == selectedpracticesId)
                })
            }
           
            dispatch(filesActions.setFilterResult(results))
        }
    }


    const clearFilters = () => {
        dispatch(filesActions.setFilterResult(null))
        // setSelectedUser(null)
        setSelectedDocumentTypeId(null)
        setSelectedpracticesId(null)
        setSelectedUserId(null)
        setKeyword(null)
    }

    return <div className={classes.container}>
        <span>Filters</span>
        <InputBox label={'Keyword'} action={searchKeywordHandler} currentValue={keyword} setStyle={'bk_white'} isAFilter={true}/>
        <CustomSelect label={'Created by'} optionsData={usersOptions} preSelectedValue={selectedUseriD} action={filterDocumentUser} hasRemove={true} isAFilter={true}/>
        <CustomSelect label={'Document Type'} optionsData={documentsTypes()} preSelectedValue={selectedDocumentTypeId} action={filterDocumentType} hasRemove={true} isAFilter={true}/>
        <CustomSelect label={'Practice'} optionsData={practicesOptions()} preSelectedValue={selectedpracticesId} action={filterPracticesHandler} hasRemove={true} isAFilter={true}/>        
        <Button click={clearFilters} btnStyle={'btn_light_grey'}>Clear</Button>
    </div>
}

export default DocumentsFilters